import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

type ChartViewToggleProps = {
  isChartView: boolean;
  onToggle: () => void;
};

/**
 * The View Chart / View Table link in a list's filter card (ID-14095, spec 6.9), beside Hide Filters
 * — Figma `Utility Button` with `table_rows`; the same button style as the filter trigger.
 */
export default function ChartViewToggle({ isChartView, onToggle }: ChartViewToggleProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Entities.ChartViewToggle' });

  return (
    <UtilButton
      data-testid="chartViewToggle"
      iconLeft={isChartView ? 'table_rows' : 'lan'}
      aria-pressed={isChartView}
      onClick={onToggle}
    >
      {isChartView ? t('viewTable', { defaultValue: 'View Table' }) : t('viewChart', { defaultValue: 'View Chart' })}
    </UtilButton>
  );
}
